import { Store } from '@ngrx/store';
import { addFundChartCalc } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/calcs/calcs.actions';
import { setFundChartSecurityGroup } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/security-group/security-group.actions';
import { setFundChartSecuritylistName } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securitylist-name/security-list-name.actions';
import { setFundChartSecuritylistSecurityId } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securitylist-security-id/security-list-security-id.actions';
import { DEFAULT_CALCS_FOR_SECURITYLIST_TYPE } from 'ChartApp/ts/features/fundamental-chart/constants';
import { COMPANY } from 'NewAngular/constants/core.constants';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "ChartApp/ts/features/charts-shared/components/chart-base-list-browser/chart-base-list-browser.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../security_lists/static/security_lists/ts/features/security-list-selector-modals/security-list-selector-modal/security-list-selector-modal.component";
/**
 *
 * Fund Chart List Browser Component
 *
 */
export class FundChartListBrowserComponent {
    constructor(store) {
        this.store = store;
        this.defaultSecurityGroup = COMPANY;
        this.mapStateToComponent = (state) => {
            const { fundChart } = state;
            this.calcs = fundChart.calcs;
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    selectSecurityList({ securityList, securityGroup, }) {
        const selectedSecuritylist = securityList.key;
        if (this.calcs.length === 0) {
            const defaultCalc = DEFAULT_CALCS_FOR_SECURITYLIST_TYPE[securityGroup];
            if (defaultCalc) {
                this.store.dispatch(addFundChartCalc({ metric: defaultCalc }));
            }
        }
        this.store.dispatch(setFundChartSecurityGroup({ securityGroup }));
        this.store.dispatch(setFundChartSecuritylistName({ securitylistName: selectedSecuritylist }));
        this.store.dispatch(setFundChartSecuritylistSecurityId({ securitylistSecurityId: '' }));
    }
}
FundChartListBrowserComponent.ɵfac = function FundChartListBrowserComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartListBrowserComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FundChartListBrowserComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartListBrowserComponent, selectors: [["ycn-fund-chart-list-browser"]], standalone: false, decls: 17, vars: 3, consts: [["helpModal", ""], ["securityListSelectorModal", ""], [1, "panel-sidebar-section-header", "user-select-none"], [1, "panel-sidebar-section-row"], [1, "panel-sidebar-section-title"], [1, "help-toggler", 3, "click"], ["name", "list_browser"], [1, "divider-vertical"], [1, "panel-sidebar-section-control"], [1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", "name", "icon-list"], [3, "submitHandler", "activeSecurityGroupTab", "clearAfterSubmit", "showSetOperations"], [1, "panel-sidebar-section-body"]], template: function FundChartListBrowserComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
        i0.ɵɵtext(3, " List Browser ");
        i0.ɵɵelementStart(4, "span", 5);
        i0.ɵɵlistener("click", function FundChartListBrowserComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(7); return i0.ɵɵresetView(helpModal_r2.openModal("list_browser")); });
        i0.ɵɵtext(5, "(?)");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "ycn-help-modal", 6, 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8)(10, "a", 9);
        i0.ɵɵlistener("click", function FundChartListBrowserComponent_Template_a_click_10_listener() { i0.ɵɵrestoreView(_r1); const securityListSelectorModal_r3 = i0.ɵɵreference(15); return i0.ɵɵresetView(securityListSelectorModal_r3.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 10);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "span");
        i0.ɵɵtext(13, "List");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "ycn-security-list-selector-modal", 11, 1);
        i0.ɵɵlistener("submitHandler", function FundChartListBrowserComponent_Template_ycn_security_list_selector_modal_submitHandler_14_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectSecurityList($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(16, "ycn-chart-base-list-browser", 12);
    } if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵproperty("activeSecurityGroupTab", ctx.defaultSecurityGroup)("clearAfterSubmit", true)("showSetOperations", false);
    } }, dependencies: [i2.ChartBaseListBrowserComponent, i3.HelpModalComponent, i4.IconDirective, i5.SecurityListSelectorModalComponent], encapsulation: 2 });
